import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function NoDocumentsIcon({ className, height, width }: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height ?? 48}
      viewBoxDimensions="0 0 216 48"
      width={width ?? 216}
    >
      <rect height="46" rx="3.5" stroke="#D1D1D1" strokeOpacity="0.5" width="215" x="0.5" y="0.5" />
      <rect fill="#F5F6FB" height="10" rx="4" width="125" x="56" y="19" />
      <circle cx="31" cy="24" fill="#F5F6FB" r="15" />
      <path
        d="M35.6667 19.96H31.3527C31.132 19.96 30.9253 19.8507 30.8013 19.668L29.8647 18.2913C29.7407 18.1093 29.5347 18 29.314 18H26.3333C25.5967 18 25 18.5967 25 19.3333V27.3333C25 28.07 25.5967 28.6667 26.3333 28.6667H35.6667C36.4033 28.6667 37 28.07 37 27.3333V21.2933C37 20.5573 36.4033 19.96 35.6667 19.96Z"
        stroke={IconColors.DarkGrey}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 22.667H25"
        stroke={IconColors.DarkGrey}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SimpleIcon>
  );
}
